/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit InlineNoteEditor/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import EditableTextArea from 'DesignSystem/EditableTextArea/react'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function InlineNoteEditor({
  children,
  viewPath = "/DesignSystem/InlineNoteEditor",
  containerId,
  width = "auto",
  paddingLeft,
  paddingRight,
  paddingTop,
  paddingBottom,
  marginTop,
  marginBottom = 0,
  overflowY = "auto",
  backgroundColor,
  parentHeight,
  tokens,
  value,
  height,
  onChange,
  toolbar = "note_template",
  maxLength,
  inline = true,
  autocomplete,
  onAutocompleteAction,
  onAutocompleteFetch,
  toolbarPersist,
  autoFocus
  
}) {
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let paddingLeftOrdtSpaceXs = paddingLeft ?? dtSpaceXs
let paddingRightOrdtSpaceXs = paddingRight ?? dtSpaceXs
let paddingTopOrdtSpaceXs = paddingTop ?? dtSpaceXs
let paddingBottomOrdtSpaceXs = paddingBottom ?? dtSpaceXs
let marginTopOrdtSpaceXs = marginTop ?? dtSpaceXs
  return (<React.Fragment
>
<div
  data-testid="InlineNoteEditor.Vertical"
  data-view-path={viewPath}
 className="views-block"
>
<div
  data-testid="InlineNoteEditor.Vertical:1"
  data-view-path={viewPath}
 id={containerId}
 style={{'--w-1-1d2b4d': typeof width === 'number' ? `${width}px` : width}}
 className={`views-block ${styles.Vertical}`}
/>
<div
  data-testid="InlineNoteEditor.Vertical:2"
  data-view-path={viewPath}
 style={{'--bc-2-1d2b4d': dtColorsNeutral200,'--pl-3-1d2b4d': typeof paddingLeftOrdtSpaceXs === 'number' ? `${paddingLeftOrdtSpaceXs}px` : paddingLeftOrdtSpaceXs,'--pr-4-1d2b4d': typeof paddingRightOrdtSpaceXs === 'number' ? `${paddingRightOrdtSpaceXs}px` : paddingRightOrdtSpaceXs,'--pt-5-1d2b4d': typeof paddingTopOrdtSpaceXs === 'number' ? `${paddingTopOrdtSpaceXs}px` : paddingTopOrdtSpaceXs,'--pb-6-1d2b4d': typeof paddingBottomOrdtSpaceXs === 'number' ? `${paddingBottomOrdtSpaceXs}px` : paddingBottomOrdtSpaceXs,'--mt-7-1d2b4d': typeof marginTopOrdtSpaceXs === 'number' ? `${marginTopOrdtSpaceXs}px` : marginTopOrdtSpaceXs,'--mb-8-1d2b4d': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--oy-9-1d2b4d': overflowY,'--bc-10-1d2b4d': backgroundColor,'--h-11-1d2b4d': typeof parentHeight === 'number' ? `${parentHeight}px` : parentHeight}}
 className={`views-block inline-editor ${styles.Vertical1}`}
>
<EditableTextArea
  viewPath={`${viewPath}/EditableTextArea`}
 tokens={tokens}
 value={value}
 height={height}
 onChange={onChange}
 toolbar={toolbar}
 maxLength={maxLength}
 menubar={false}
 inline={inline}
 selector="inline-editor"
 inlineToolbarContainer={containerId}
 autocomplete={autocomplete}
 onAutocompleteAction={onAutocompleteAction}
 onAutocompleteFetch={onAutocompleteFetch}
 toolbarPersist={toolbarPersist}
 autoFocus={autoFocus}
/>
</div>
</div>
{children}
</React.Fragment>)
}